import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';

/**
 * @Entity ChancenRoleMultiAspect
 */
@Entity()
export class ChancenRoleMultiAspect extends AbstractAspect {
  static override _class = 'ChancenRoleMultiAspect';

  constructor(doc: PartialEntityData<ChancenRoleMultiAspect>) {
    const newDoc = { customID: 'semanticRoles', ...doc };
    super(newDoc);
  }

  @Field(() => [ID], { default: v => v ?? [] })
  values!: string[];
  @Field(() => [String], { default: v => v ?? [] })
  names!: string[];
}
